import { Core } from "@faire/design-tokens";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  onDelete: () => void;
  isDeleting: boolean;
  ariaLabel?: string;
  className?: string;
}

export const ResultDropdownDeleteButton: React.FC<IProps> = ({
  onDelete,
  isDeleting,
  ariaLabel,
  className,
}) => {
  if (isDeleting) {
    /*loading state for delete button*/
    return (
      <StyledDeleteButton className={className}>
        <LoadingSpinner size="small" data-test-id="deleting-search" />
      </StyledDeleteButton>
    );
  } else {
    return (
      <StyledDeleteButton
        className={className}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          onDelete();
        }}
        // Prevent ResultsDropdown from closing when clicking delete button
        onMouseDown={(event) => event.preventDefault()}
        aria-label={ariaLabel}
        tabIndex={-1}
      >
        <Close />
      </StyledDeleteButton>
    );
  }
};

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/IconButton/IconButton#IconButton"
 */
const StyledDeleteButton = styled.button`
  display: flex;
  align-content: center;
  color: ${Core.text.subdued};

  &:hover {
    color: ${Core.text.default};
  }
`;
